import React from 'react'
import { NavigateFunction,useNavigate } from 'react-router-dom'
import PhoneInput,{ parsePhoneNumber,formatPhoneNumber } from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import { E164Number } from 'libphonenumber-js/types.cjs'
import { Dialog } from 'primereact/dialog'
import { InputText } from 'primereact/inputtext'
import { Checkbox } from 'primereact/checkbox'
import { Skeleton } from 'primereact/skeleton'
import { Button } from 'primereact/button'
import { sendSmsOtpForLogin,verifySmsOtp } from '_services/auth.service'
import useAuth from '../../../_core/hooks/useAuth'
import SubmitButton from '../../../components/submit-button'
//import { useUserback } from '@userback/react'
import EditableField from '../../auth/_forms/_components/EditableField'

type Differentiator = { kind:'phone',phone:string,code:string;rawphone:E164Number } | { kind:'email',email:string }

const resendTimeout = 30 * 1000

const phoneToDifferentiator = (number:E164Number) : Differentiator => {
  const parsed = parsePhoneNumber(number as string)
  const formattedNumber = parsed!.nationalNumber.toString()
  const countryCode = parsed!.countryCallingCode.toString()
  return { 'kind':'phone','phone':formattedNumber,'code':countryCode,'rawphone':number }
}

enum EnumAction {
  LOADING='loading',
  CHOOSE='choose',

  OTP='otp',
  OTP_INVALID='otp-invalid',
  OTP_RESET='otp-reset',

  SIGNIN_DBG='signin-dbg',
  SIGNIN_DATP='signin-datp',
  CONFIRM_PHONE='confirm-phone',

  SUBMIT='submit',

  CHANGE_PHONE='change-phone',
  CHANGE_EMAIL='change-email',
  CHANGE_OTP='change-otp',
  CHANGE_TOS='change-tos',
}

type Action = {
  'action':EnumAction.LOADING
} | {
  'action':EnumAction.CHOOSE
} | {
  'action':EnumAction.OTP
  'kind':'phone'
  'phone':string
  'rawphone':E164Number
  'code':string
} | {
  'action':EnumAction.OTP
  'kind':'email'
  'email':string
} | {
  'action':EnumAction.OTP_INVALID | EnumAction.OTP_RESET
} | {
  'action':EnumAction.CONFIRM_PHONE
} | {
  'action':EnumAction.SIGNIN_DATP
} | {
  'action':EnumAction.SIGNIN_DBG
} | {
  'action':EnumAction.SUBMIT
  'submitting':Promise<unknown>
} | {
  'action':EnumAction.CHANGE_PHONE
  'phoneNumber':E164Number | undefined
} | {
  'action':EnumAction.CHANGE_EMAIL
  'email':string
} | {
  'action':EnumAction.CHANGE_OTP
  'otp':string
} | {
  'action':EnumAction.CHANGE_TOS
  'tos':boolean
}

enum EnumState {
  LOADING='loading',
  CHOOSE='choose',
  SIGNIN_DATP='signin_datp',
  SIGNIN_DBG='signin_dbg',
  OTP='otp',
  CONFIRM_PHONE='confirm-phone',
}

type State = {
  'state':EnumState.LOADING
} | {
  'state':EnumState.CHOOSE
} | {
  'state':EnumState.SIGNIN_DATP
  'phoneNumber':E164Number | undefined
  'tos':boolean
  'submitting':Promise<unknown> | undefined
  'invalid':boolean
} | {
  'state':EnumState.SIGNIN_DBG
  'email':string
  'tos':boolean
  'submitting':Promise<unknown> | undefined
  'invalid':boolean
} | {
  'state':EnumState.OTP
  'kind':'email'
  'email':string
  'token':string
  'resend':boolean
  'submitting':Promise<unknown> | undefined
  'invalid':boolean
} | {
  'state':EnumState.OTP
  'kind':'phone'
  'phone':string
  'rawphone':E164Number
  'code':string
  'token':string
  'resend':boolean
  'submitting':Promise<unknown> | undefined
  'invalid':boolean
} | {
  'state':EnumState.CONFIRM_PHONE
  'phoneNumber':E164Number | undefined
  'submitting':Promise<unknown> | undefined
}

const reducer = (s:State,a:Action) : State => {
  switch(a.action)
  {
    case EnumAction.LOADING:
      return { 'state':EnumState.LOADING }
    case EnumAction.CHOOSE:
      return { 'state':EnumState.CHOOSE }
    case EnumAction.CONFIRM_PHONE:
      return { 'state':EnumState.CONFIRM_PHONE,'phoneNumber':undefined,'submitting':undefined }
    case EnumAction.OTP:
      switch(a.kind)
      {
        case 'phone':
          return { 'state':EnumState.OTP,'kind':'phone','phone':a.phone,'rawphone':a.rawphone,'code':a.code,'token':'','submitting':undefined,'resend':false,'invalid':false }
        case 'email':
          return { 'state':EnumState.OTP,'kind':'email','email':a.email,'token':'','submitting':undefined,'resend':false,'invalid':false }
      }
    case EnumAction.OTP_RESET:
      switch(s.state)
      {
        case EnumState.OTP:
          return { ...s,'resend':true }
        default:
          return s
      }
    case EnumAction.OTP_INVALID:
      switch(s.state)
      {
        case EnumState.SIGNIN_DATP:
        case EnumState.SIGNIN_DBG:
          return { ...s,'invalid':true }
        default:
          return s
      }
    case EnumAction.SIGNIN_DATP:
      return { 'state':EnumState.SIGNIN_DATP,'phoneNumber':undefined,'tos':false,'submitting':undefined,'invalid':false }
    case EnumAction.SIGNIN_DBG:
      return { 'state':EnumState.SIGNIN_DBG,'email':'','tos':false,'submitting':undefined,'invalid':false }
    case EnumAction.SUBMIT:
      switch(s.state)
      {
        case EnumState.OTP:
          return { ...s,'token':'','submitting':a.submitting }
        case EnumState.SIGNIN_DATP:
        case EnumState.SIGNIN_DBG:
        case EnumState.CONFIRM_PHONE:
          return { ...s,'submitting':a.submitting }
        default:
          return s
      }
    case EnumAction.CHANGE_EMAIL:
      switch(s.state)
      {
        case EnumState.SIGNIN_DBG:
          return { ...s,'email':a.email }
        default:
          return s
      }
    case EnumAction.CHANGE_PHONE:
      switch(s.state)
      {
        case EnumState.SIGNIN_DATP:
        case EnumState.CONFIRM_PHONE:
          return { ...s,'phoneNumber':a.phoneNumber }
        default:
          return s
      }
    case EnumAction.CHANGE_TOS:
      switch(s.state)
      {
        case EnumState.SIGNIN_DATP:
        case EnumState.SIGNIN_DBG:
          return { ...s,'tos':a.tos }
        default:
          return s
      }
    case EnumAction.CHANGE_OTP:
      switch(s.state)
      {
        case EnumState.OTP:
          return { ...s,'token':a.otp }
        default:
          return s
      }
  }
}

const Content = ({ state,dispatch,navigate,setAuth }:{ state:State;dispatch:React.Dispatch<Action>,navigate:NavigateFunction,setAuth:(_:string) => void }) => {
  const generateOTP = async (data:Differentiator) => {
    switch(data.kind)
    {
      case 'phone':{
        dispatch({ 'action':EnumAction.LOADING })
        try
        {
          const response = await sendSmsOtpForLogin('phone',data.phone,data.code)
          switch(response.data.status)
          {
            case 'otp':
              dispatch({ 'action':EnumAction.OTP,'kind':'phone','phone':data.phone,'rawphone':data.rawphone,'code':data.code })
              setTimeout(() => dispatch({ 'action':EnumAction.OTP_RESET }),resendTimeout)
              break
            case 'phoneRequired':
              dispatch({ 'action':EnumAction.CONFIRM_PHONE })
              break
            default:
              // TODO: error?
              break
          }
        }
        catch(e)
        {
          dispatch({ 'action':EnumAction.OTP_INVALID })
        }
        break
      }
      case 'email':{
        dispatch({ 'action':EnumAction.LOADING })
        try
        {
          const response = await sendSmsOtpForLogin('email',data.email,'')
          switch(response.data.status)
          {
            case 'otp':
              dispatch({ 'action':EnumAction.OTP,'kind':'email','email':data.email })
              setTimeout(() => dispatch({ 'action':EnumAction.OTP_RESET }),resendTimeout)
              break
            case 'phoneRequired':
              dispatch({ 'action':EnumAction.CONFIRM_PHONE })
              break
            default:
              // TODO: error?
              break
          }
        }
        catch(e)
        {
          dispatch({ 'action':EnumAction.OTP_INVALID })
        }
        break
      }
    }
  }

  const confirmOTP = async (emailphone:Differentiator,token:string) => {
    const submitting
      = emailphone.kind === 'phone'
      ? verifySmsOtp(emailphone.phone,token,'')
      : emailphone.kind === 'email'
      ? verifySmsOtp(emailphone.email,token,'')
      : new Promise((resolve) => resolve({ 'error':'IMPOSSIBLE' }))
    dispatch({ 'action':EnumAction.SUBMIT,'submitting':submitting })
    const res = await submitting
    if(res.error)
    {
      dispatch({ 'action':EnumAction.OTP_INVALID })
    }
    else
    {
      switch(res.data.status)
      {
        case 'completedUser':
          setAuth(res.data.token)
          navigate('/discover')
          break
        case 'pendingUser':
          setAuth(res.data.token)
          navigate('/onboarding')
          break
        case 'phoneRequired':
          setAuth(res.data.token)
          dispatch({ 'action':EnumAction.CONFIRM_PHONE })
          break
      }
    }
  }

  const resendOtp = (emailphone:Differentiator) => {
    return (
      emailphone.kind === 'phone'
      ? sendSmsOtpForLogin('phone',emailphone.phone,emailphone.code)
      : emailphone.kind === 'email'
      ? sendSmsOtpForLogin('phone',emailphone.email,'')
      : undefined
    )
  }
  switch(state.state)
  {
    case EnumState.LOADING:
      return <Skeleton></Skeleton>
    case EnumState.CHOOSE:
      return <>
        <h3 className="text-center">Get Started</h3>
        <div className="d-flex flex-column justify-content-center">
          <button className="btn btn-dark" onClick={() => dispatch({ 'action':EnumAction.SIGNIN_DBG })}>
            Log in with email
          </button>
          <button className="btn btn-dark" onClick={() => dispatch({ 'action':EnumAction.SIGNIN_DATP })}>
            Log in with phone number
          </button>
          <p>** Note: <small>In order to connect an existing DBG account, email must be used on first login.</small></p>

        </div>
      </>
    case EnumState.SIGNIN_DATP:
      return <>
        <form
          className="d-flex flex-column align-items-center"
          onSubmit={(e) => {
            e.preventDefault()
            dispatch({ 'action':EnumAction.SUBMIT,'submitting':generateOTP(phoneToDifferentiator(state.phoneNumber!)) })
          }}
        >
          <span className="p-float-label mb-2" style={{width:'80%',maxWidth:300}}>
            <PhoneInput
              ref={(x) => x?.focus()}
              placeholder="Phone Number"
              value={state.phoneNumber}
              onChange={(x) => dispatch({ 'action':EnumAction.CHANGE_PHONE,'phoneNumber':x })}
              defaultCountry="US"
            />
            {state.invalid && <i className="text-danger">Invalid phone. Please try again.</i>}
          </span>
          <div className="d-flex">
            <Checkbox
              className='my-2'
              style={{ marginRight: 4 }}
              inputId="tos"
              name="tos"
              value="accepted"
              onChange={(e) => dispatch({ 'action':EnumAction.CHANGE_TOS,'tos':e.checked! })}
              checked={state.tos}
            />
            <label htmlFor="tos" className="mt-1 signIn-label">
              I have read and agreed to <span className='fw-medium'>Dating Across the Pond</span> <a href="/terms-and-conditions">Terms of use</a> and <a href="/privacy-policy">Privacy Policy</a>
            </label>
          </div>
          <div className="d-flex align-items-center justify-content-center">
            <div className="d-flex justify-content-between">
              <SubmitButton
                dependency={state.submitting}
                label="Submit"
                disabled={!state.tos || !state.phoneNumber}
                className="my-3"
              />
            </div>
          </div>
        </form>
      </>
    case EnumState.SIGNIN_DBG:
      return <>
        <form
          className="d-flex flex-column align-items-center"
          onSubmit={(e) => {
            e.preventDefault()
            dispatch({ 'action':EnumAction.SUBMIT,'submitting':generateOTP({ 'kind':'email','email':state.email }) })
          }}
        >
          <span className="p-float-label mb-2" style={{width:'80%',maxWidth:300}}>
            <EditableField
              // ref={(x) => x?.focus()}
              placeholder="Email"
              value={state.email}
              onChange={(e) => dispatch({ 'action': EnumAction.CHANGE_EMAIL, 'email': e })}
              label={'Email'}
              errors={state.invalid ? 'Invalid email. Please try again.' : undefined}
            />
          </span>
          <div className="d-flex">
            <Checkbox
              className='my-2'
              style={{ marginRight: 4 }}
              inputId="tos"
              name="tos"
              value="accepted"
              onChange={(e) => dispatch({ 'action':EnumAction.CHANGE_TOS,'tos':e.checked! })}
              checked={state.tos}
            />
            <label htmlFor="tos" className="mt-1 signIn-label">
              I have read and agreed to <span className='fw-medium'>Dating Across the Pond</span> <a href="/terms-and-conditions">Terms of use</a> and <a href="/privacy-policy">Privacy Policy</a>
            </label>
          </div>
          <div className="d-flex align-items-center justify-content-center">
            <div className="d-flex justify-content-between">
              <SubmitButton
                dependency={state.submitting}
                label="Submit"
                disabled={!state.tos || !state.email}
                className="my-3"
              />
            </div>
          </div>
        </form>
      </>
    case EnumState.OTP:
      return <>
        <form
          onSubmit={(e) => {
            e.preventDefault()
            confirmOTP(state,state.token)
          }}
        >
          <div className="d-flex flex-column align-items-center">
            <p className="font-bold text-xl-center mb-2">Authenticate Your Account</p>
            <p className="text-color-secondary d-block mb-2">
              Please enter the code sent to {state.kind === 'phone' ? formatPhoneNumber(state.rawphone) : state.kind === 'email' ? state.email : '-'}.
            </p>
            <div className="d-flex flex-column justify-content-center text-center my-4">
              <InputText
                ref={(x) => x?.focus()}
                value={state.token}
                onChange={(e) => {
                  dispatch({ 'action':EnumAction.CHANGE_OTP,'otp':e.target.value })
                  if(e.target.value.length === 6)
                  {
                    confirmOTP(state,e.target.value)
                  }
                }}
                maxLength={6}
                className="text-center"
                placeholder="Please Enter Code"
              />
              {state.invalid && <i className="text-danger">Invalid code. Please try again.</i>}
            </div>
            <div className="d-flex justify-content-between align-self-stretch mt-2">
              <Button type="button" label="Resend Code" link onClick={() => resendOtp(state)} disabled={!state.resend}></Button>
              <SubmitButton
                dependency={state.submitting}
                label="Submit Code"
                className="my-3"
              />
            </div>
          </div>
        </form>
      </>
    case EnumState.CONFIRM_PHONE:
      return <>
        <form
          className="d-flex flex-column align-items-center"
          onSubmit={(e) => {
            e.preventDefault()
            dispatch({ 'action':EnumAction.SUBMIT,'submitting':generateOTP(phoneToDifferentiator(state.phoneNumber!)) })
          }}
        >
          <span className="p-float-label mb-2 w-50">
            <p>Please add your mobile number, or you may X out of this window and just use email to login.</p>
          <PhoneInput
              ref={(x) => x?.focus()}
              placeholder="Enter phone number"
              value={state.phoneNumber}
              onChange={(x) => dispatch({ 'action':EnumAction.CHANGE_PHONE,'phoneNumber':x })}
              defaultCountry="US"
            />
          </span>
          <div className="d-flex align-items-center justify-content-center">
            <div className="d-flex justify-content-between">
             <SubmitButton
                dependency={state.submitting}
                label="Next"
                className="my-3 ms-auto"
              />
            </div>
          </div>
        </form>
      </>
  }
}

const SignInModal = (props:{ isCreateModal?:boolean,title?:string,isVisible:boolean,onClose:() => void }) => {
  const [state,dispatch] = React.useReducer(reducer,{ 'state':EnumState.CHOOSE })
  const navigate = useNavigate()
  //const openUserback = localStorage.getItem('ENVIRONMENT') === 'production' ? useUserback() : { 'open':() => alert('Only implemented in Production') }
const openUserback = { 'open':() => alert('Only implemented in Production') }
  const [_,setAuth] = useAuth()

  const onHide = () => {
    props.onClose()
    dispatch({ 'action':EnumAction.CHOOSE })
  }

  return (
    <Dialog
      className="h-100 h-md-auto"
      header={props.title}
      visible={props.isVisible}
      onHide={onHide}
      headerClassName="p-1 p-md-3"
      contentClassName="p-1 p-md-3"
      style={{ width:'100%',maxWidth:'850px',maxHeight:'100%' }}
    >
      <div className="p-2 p-sm-3 p-md-5">
        {/* <div className="text-center img-fluid">
          <img src="../../../assets/images/horizontal-logo.png" alt="Brand title" />
        </div> */}
        <Content state={state} dispatch={dispatch} navigate={navigate} setAuth={setAuth}></Content>
        
		<div className="d-flex justify-content-center align-items-center">
		  <Button
			className="color-primary"
			label="Having trouble signing-in?"
			link
			onClick={() => {
			  window.location.href = 'mailto:support@datingacrossthepond.com?subject=Trouble%20Signing%20Up';
			}}
		  />
		</div>
		
		
      </div>
    </Dialog>
  )
}

export default SignInModal
